var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"read-more"},[_c('BfMarkdown',{ref:"content",class:[
      "read-more__content",
      _vm.open ? 'open' : ''
    ],style:({ lineHeight: 1.25 })},[_vm._v(" "+_vm._s(_vm.content)+" ")]),(_vm.displayReadMoreLink)?_c('a',{attrs:{"tabindex":"0"},on:{"click":function($event){_vm.open = !_vm.open}}},[_vm._v(" Read "+_vm._s(_vm.open ? 'Less' : 'More')+" ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }